import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import PublicHeader from "./components/PublicHeader";
import { useLocation } from "react-router-dom";

export default function PublicLayout() {
    const [dark] = useState(() => localStorage.getItem("theme") === "dark");
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const isLoginPage = String(location.pathname || "").toLowerCase().includes("/login");


    useEffect(() => setMobileOpen(false), [location.pathname]);

    useEffect(() => {
        localStorage.setItem("theme", dark ? "dark" : "light");
        // แนะนำให้ toggle ที่ <html> ครอบทั้งระบบจริง ๆ
        document.documentElement.classList.toggle("invert-mode", dark);
    }, [dark]);

    return (
        <div className="min-h-screen bg-white">
            {/* <button
                onClick={() => setDark((v) => !v)}
                className="fixed bottom-6 right-6 z-[9999] px-4 h-11 rounded-xl bg-slate-900 text-white"
            >
                {dark ? "โหมดสว่าง" : "โหมดมืด"}
            </button> */}
            {!isLoginPage && <PublicHeader />}
            <Outlet />
        </div>
    );
}
